module.exports = __webpack_public_path__ + "img/chevron-left.8fed43a1.svg";